import type { UserCompany } from "../services/auth.service";
import {
  findPrimaryUserCompany,
  getUserCompanyId,
  getVisibleUserCompanies,
} from "./organization-services-license.util";

/** Account service personal org — not a workplace clinic org. */
export const PERSONAL_ORGANIZATION_ID =
  "27a8906a-a8ab-415f-9128-029901816a91";

/** Account service professional org — not a workplace clinic org. */
export const PROFESSIONAL_ORGANIZATION_ID =
  "27a8906a-a8ab-415f-9128-029901816a92";

const RESERVED_ORG_NAMES = new Set(["personal", "professional"]);

export function isReservedAccountOrganization(
  userCompany: UserCompany
): boolean {
  const companyId = getUserCompanyId(userCompany)?.toLowerCase();
  if (companyId === PERSONAL_ORGANIZATION_ID.toLowerCase()) {
    return true;
  }
  if (companyId === PROFESSIONAL_ORGANIZATION_ID.toLowerCase()) {
    return true;
  }
  const name = (
    userCompany.companyName ||
    userCompany.company?.name ||
    ""
  )
    .trim()
    .toLowerCase();
  return RESERVED_ORG_NAMES.has(name);
}

/** Visible memberships excluding Personal / Professional account orgs. */
export function getWorkplaceUserCompanies(
  userCompanies: UserCompany[] | null | undefined
): UserCompany[] {
  return getVisibleUserCompanies(userCompanies).filter(
    (uc) => !isReservedAccountOrganization(uc)
  );
}

/** Direct auth login (not Ask Aya handoff) with multiple workplace orgs. */
export function shouldPromptCompanySelectionOnDirectLogin(input: {
  userCompanies?: UserCompany[] | null;
  isFromAyaLaunch?: boolean;
}): boolean {
  if (input.isFromAyaLaunch) {
    return false;
  }
  return getWorkplaceUserCompanies(input.userCompanies).length > 1;
}

/** Multiple workplace orgs where the user has marked a primary organization. */
export function hasPrimaryWorkplaceOrganization(
  userCompanies: UserCompany[] | null | undefined
): boolean {
  return !!findPrimaryUserCompany(userCompanies);
}
